import React, { Fragment } from 'react'
import { Link } from 'gatsby'

import SEO from '../../../components/seo'
import Layout from '../../../components/layout'
import Servizio from '../../../components/Servizio'

import DepotPickupImg from '../../../images/depot_pickup.jpg'

const paginaServizio = {
  titolo: 'Depot pickup',
  parent: {
    nome: 'Accessori',
    linkUrl: '/servizi/servizi-accessori',
  },
  servizi: [
    {
      id: 1,
      nome: '',
      imgUrl: DepotPickupImg,
      paragrafi: [
        {
          id: 1,
          testo:
            'Il servizio consente al destinatario di ritirare la spedizione fino al terzo giorno lavorativo successivo all’arrivo presso la Sede più vicina. È disponibile dal lunedì al venerdì dalle 8.30 alle 13.00 e dalle 14.30 alle 18.30. Inoltre DepotPickup-Service prevede che la merce possa essere ritirata anche al sabato mattina, dalle ore 8.30 alle ore 12.00.',
        },
      ],
      pesoDimensioni: null,
      vantaggi: [
        {
          id: 1,
          testo: 'Organizza il flusso delle tue spedizioni con flessibilità',
        },
        {
          id: 2,
          testo:
            'Personalizza la gestione delle spedizioni sia per te che per i tuoi clienti',
        },
        {
          id: 3,
          testo:
            'Prenotazione del servizio tramite telefono, e-mail, Weblabeling (per maggiori informazioni contatta la tua Sede di riferimento), o eventualmente via fax',
        },
      ],
      compatibileCon: [
        {
          id: 1,
          nome: 'National Express',
          linkUrl: '/servizi/national-express',
        },
        {
          id: 2,
          nome: 'Safe Plus',
          linkUrl: '/servizi/safe-plus',
        },
        {
          id: 5,
          nome: 'Logistics',
          linkUrl: '/servizi/logistics',
        },
      ],
      servizi: null,
    },
  ],
}

const DepotPickup = () => {
  return (
    <Layout>
      <SEO
        title={paginaServizio.titolo}
        description={paginaServizio.servizi[0].paragrafi[0].testo}
      />
      <section className="py-8 px-6">
        <h1 className="text-3xl sm:text-4xl font-light text-gls-blue-900 leading-tight">
          {!!paginaServizio.parent && (
            <Link
              to={paginaServizio.parent.linkUrl}
              className="mr-2 text-lg text-gls-blue-600 hover:text-gls-blue-700"
            >
              {paginaServizio.parent.nome} &raquo;
            </Link>
          )}
          {paginaServizio.titolo}
        </h1>
      </section>
      <section className="bg-white lg:rounded-lg shadow-xl">
        {paginaServizio.servizi.map((servizio, index) => {
          return (
            <Fragment key={servizio.id}>
              <Servizio servizio={servizio} />
              {index < paginaServizio.servizi.length - 1 && <hr />}
            </Fragment>
          )
        })}
      </section>
    </Layout>
  )
}

export default DepotPickup
